// extracted by mini-css-extract-plugin
module.exports = {"historyCompressionReceives":"HistoryCompressionReceives_historyCompressionReceives__3uuUs","commonCard":"HistoryCompressionReceives_commonCard__1PnY7"};